export default __webpack_public_path__ + "static/media/b_slide3.03c6ed81.jpg";